import React from 'react';

const Footer: React.FC = () => {
  return (
    <div className="container-copyright" id="summary">
      <div className="row">
        <div className="col-md-12">
          <p className="copyright">
            © American Institute For Chartered Property Casualty Underwriters.
            All rights reserved.{' '}
          </p>
        </div>
      </div>
    </div>
  );
};
export default Footer;
